import React from 'react';
import styled from 'styled-components';
import { device } from 'js/config/style';

import DAIStepNumber from './DAIStepNumber';

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media(max-width: calc(${device.laptop} - 1px)) {
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  @media(min-width: ${device.laptop}) {
    flex-direction: row;
  }
`;

const InfographicItem = styled.div`
@media(min-width: ${device.laptop}) {
  &.pod-infographic-item {
    display: flex;
    flex-direction: row;
  }

  &.pod-infographic-item {
    position: relative;
  }

  &.pod-infographic-item::after {
    margin: 0 auto;
    position: relative;
    min-width: 95px;
    height: 65px;
    background-repeat: no-repeat;
    align-self: center;
  }

  &.pod-infographic-item:nth-child(2n)::after {
    content: "";
    background-image: url(/images/buyer-page-info-steps/arrow_right_up.svg);
    display: inline-block;
  }

  &.pod-infographic-item:nth-child(2n+1) .pod-ii-content {
    margin-bottom: 70px;
  }

  .pod-infographic-item:nth-child(2n) .pod-ii-content {
    margin-top: 70px;
  }

  &.pod-infographic-item:nth-child(2n+1)::after {
    content: "";
    background-image: url("/images/buyer-page-info-steps/arrow_right_down.svg");
    display: inline-block;
  }

  &.pod-infographic-item:last-child::after {
    display: none;
  }
}

@media(max-width: ${device.laptop}) {
  &.pod-infographic-item {
    min-width: 100%;
    height: 100%;
    justify-content: center;
    display: inline-flex;
    flex-direction: column;
  }
}
`;

function DottedArrowInfographicItem({ 
  children,
  step 
}) {
  return (
    <InfographicItem className="pod-infographic-item">
      <div className="pod-ii-content">
        <ContentContainer>
          <DAIStepNumber step={step || 0} />
          {children}
        </ContentContainer>
      </div>
    </InfographicItem>
  );
}

export default DottedArrowInfographicItem;